"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Game = void 0;
require("reflect-metadata");
const Ticker_1 = require("./Common/Ticker");
const GameConfig_1 = require("./Core/GameConfig");
const inversify_1 = require("inversify");
const LoadingScene_1 = require("./Scenes/LoadingScene");
const SymbolClasses_1 = require("./Utils/SymbolClasses");
const Utils_1 = require("./Utils/Utils");
const SceneSwitcher_1 = require("./Scenes/SceneSwitcher");
const pixi_js_1 = require("pixi.js");
class Game {
    constructor(canvas, config, loadConfig) {
        this.stage = new SymbolClasses_1.MainStage();
        this.ticker = new Ticker_1.Ticker();
        this.ioc = new inversify_1.Container({ skipBaseClassChecks: true });
        this.events = new SymbolClasses_1.GlobalEvents();
        this._destroyed = false;
        if (!GameConfig_1.GameConfig.validate(config)) {
            throw new Error("invalid GameConfig");
        }
        if (!GameConfig_1.GameLoadConfig.validate(loadConfig)) {
            throw new Error("invalid GameLoadConfig");
        }
        this.renderer = pixi_js_1.autoDetectRenderer({
            view: canvas,
            width: canvas.clientWidth,
            height: canvas.clientHeight,
            resolution: config.resolution,
        });
        this.ioc.bind(inversify_1.Container).toConstantValue(this.ioc);
        this.ioc.bind(SymbolClasses_1.MainStage).toConstantValue(this.stage);
        this.ioc.bind(SymbolClasses_1.GlobalEvents).toConstantValue(this.events);
        if (config instanceof GameConfig_1.GameConfig)
            this.ioc.bind(GameConfig_1.GameConfig).toConstantValue(config);
        else
            this.ioc.bind(GameConfig_1.GameConfig).toConstantValue(Object.assign(new GameConfig_1.GameConfig(), config));
        if (loadConfig instanceof GameConfig_1.GameLoadConfig)
            this.ioc.bind(GameConfig_1.GameLoadConfig).toConstantValue(loadConfig);
        else
            this.ioc.bind(GameConfig_1.GameLoadConfig).toConstantValue(Object.assign(new GameConfig_1.GameLoadConfig(), loadConfig));
        this.ioc.bind(SceneSwitcher_1.SceneSwitcher).toSelf().inSingletonScope();
        this.ticker.Tick.add((delta, now) => {
            this.resize();
            this.events.Update.emit(delta, now);
            this.renderer.render(this.stage);
        });
        this.resize();
        this.stage.addChild(this.ioc.resolve(LoadingScene_1.LoadingScene));
        Utils_1.addAutoListener(window, "blur", remove => {
            if (this._destroyed)
                return remove();
            this.events.WindowBlur.emit();
            this.ticker.Stop();
        });
        Utils_1.addAutoListener(window, "focus", remove => {
            if (this._destroyed)
                return remove();
            this.ticker.Start();
            this.events.WindowFocus.emit();
        });
        this.events.End.add(remove => {
            if (this._destroyed)
                return remove();
            this.destroy();
        });
    }
    start() {
        this.ticker.Start();
    }
    pause() {
        this.ticker.Stop();
    }
    destroy() {
        if (this._destroyed)
            return;
        this._destroyed = true;
        this.ticker.Stop();
        this.ticker.Tick.clear();
        this.events.End.emit();
        for (const e in this.events)
            this.events[e].clear();
        this.ioc.unbindAll();
        this.stage.destroy({ children: true });
        this.renderer.clear();
        this.renderer.destroy();
        pixi_js_1.utils.clearTextureCache();
        if (this.ondestroyed instanceof Function)
            this.ondestroyed();
    }
    resize() {
        const h = window.innerHeight;
        const w = window.innerWidth;
        const s = this.renderer.screen;
        if (h !== s.height || w !== s.width || !this.events.Resize.prevArgs) {
            this.renderer.resize(w, h);
            this.events.Resize.emit(w, h);
        }
    }
}
exports.Game = Game;
//# sourceMappingURL=Game.js.map